import Sofive from './../../images/sofive.png'
import Scoreplay from './../../images/scoreplay.png'

export default {
  css: 'green/green.css',
  left_image: {
    img: Sofive,
    width: '70%',
  },
  right_image: {
    img: Scoreplay,
    width: '90%',
  },
  fouls: true,
  fouls_image: null,
}
